import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Initial time: 23h 59m 03s in seconds
  const initialTime = 23 * 3600 + 59 * 60 + 3;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex justify-center items-center gap-4 my-6" data-id="element-64">
      <div className="flex flex-col items-center" data-id="element-65">
        <div className="bg-black text-white text-4xl md:text-5xl font-bold py-3 px-4 rounded-md min-w-[70px] md:min-w-[80px] text-center" data-id="element-66">
          {formatNumber(hours)}
        </div>
        <span className="text-white text-xs mt-2 font-semibold tracking-wider" data-id="element-67">
          HS
        </span>
      </div>
      <div className="text-white text-3xl font-bold pb-6" data-id="element-68">:</div>
      <div className="flex flex-col items-center" data-id="element-69">
        <div className="bg-black text-white text-4xl md:text-5xl font-bold py-3 px-4 rounded-md min-w-[70px] md:min-w-[80px] text-center" data-id="element-70">
          {formatNumber(minutes)}
        </div>
        <span className="text-white text-xs mt-2 font-semibold tracking-wider" data-id="element-71">
          MIN
        </span>
      </div>
      <div className="text-white text-3xl font-bold pb-6" data-id="element-72">:</div>
      <div className="flex flex-col items-center" data-id="element-73">
        <div className="bg-black text-white text-4xl md:text-5xl font-bold py-3 px-4 rounded-md min-w-[70px] md:min-w-[80px] text-center" data-id="element-74">
          {formatNumber(seconds)}
        </div>
        <span className="text-white text-xs mt-2 font-semibold tracking-wider" data-id="element-75">
          SEG
        </span>
      </div>
    </div>;
}